import moment from "moment";
import { getWeekDaysFromDateRange } from "@/utils/dates";
import Loader from "@/components/loader/Loader.vue";
import { FacilitySettingsModel } from "@/models/FacilitySettings";

export default {
  name: "LifestyleEventsReport",
  data() {
    return {
      period: "month",
      startDate: moment().subtract(1, "month").toISOString().substring(0, 10),
      endDate: moment().toISOString().substring(0, 10),
      timeFormat: null,
      flexHeight: 250,
      loading: false,
      picker: {
        start: false,
        end: false
      },
      periods: [],
      headers: [],
      jsonFields: {
        "Event": "eventName",
        "Lifestyle program": "socialClubsNames",
        "Type": "isVirtualEvent",
        "Dimension": "eventCategories",
        "Resident": "residentName",
        "Location": "location",
        "Recurring event": "isRecurring",
        "Date": "eventStart"
      },

      eventsByHour: [],
      eventsByDate: [],
      dailyCount: [],
    }
  },
  components: {
    Loader
  },
  computed: {
    facility(): FacilitySettingsModel {
      return this.$store.state.facilityModule.selectedFacility;
    },
    report() {
      this.loading = false
      return this.$store.state.calenderModule.lifestyleEventsReportData;
    },
    formattedSelectedDateRange() {
      return `${moment(this.startDate).format(this.facility.dateFormat)} - ${moment(this.endDate).format(this.facility.dateFormat)}`
    },
    formattedStartDate() {
      return moment(this.startDate).format(this.facility.dateFormat)
    },
    formattedEndDate() {
      return moment(this.endDate).format(this.facility.dateFormat)
    },
  },
 
  async created() {
    if(this.$route.params.facilityId && (this.$store.state.authModule.currentFacility !== this.$route.params.facilityId)){
      this.loading = true
      await this.changeCurrentFacility(this.$route.params.facilityId)
      this.loading = false
    }

    this.getEventsByDates()
    this.timeFormat = this.facility.timeFormat.includes('A')?'hh  A':'HH'
    this.headers = [
      { text: this.$i18n.messages[this.$i18n.locale]["LifestyleEventsReport.Event"], value: "eventName" },
      { text: this.$i18n.messages[this.$i18n.locale]["LifestyleEventsReport.LifestyleProgram"], value: "socialClubsNames" },
      { text: this.$i18n.messages[this.$i18n.locale]["LifestyleEventsReport.Type"], value: "isVirtualEvent" },
      { text: this.$i18n.messages[this.$i18n.locale]["LifestyleEventsReport.Dimension"], value: "eventCategories" },
      { text: this.$i18n.messages[this.$i18n.locale]["LifestyleEventsReport.Resident"], value: "residentName" },
      { text: this.$i18n.messages[this.$i18n.locale]["LifestyleEventsReport.Location"], value: "location" },
      { text: this.$i18n.messages[this.$i18n.locale]["LifestyleEventsReport.RecurringEvent"], value: "isRecurring" },
      { text: this.$i18n.messages[this.$i18n.locale]["LifestyleEventsReport.Date"], value: "eventStart" }
    ]
    this.periods = [
      { title: this.$i18n.messages[this.$i18n.locale]["GeneralTranslations.Week"], value: "week" },
      { title: this.$i18n.messages[this.$i18n.locale]["GeneralTranslations.Month"], value: "month" },
      { title: this.$i18n.messages[this.$i18n.locale]["GeneralTranslations.Year"], value: "year" }
    ]
  },
  watch: {
    "report"(report) {
      this.eventsByDate = this.groupByDay(report.lifestyleEvents)
      this.dailyCount = this.getDailyCount(report.lifestyleEvents)
      this.eventsByHour = this.groupByHour(report.lifestyleEvents)
    }
  },
  methods: {
    async changeCurrentFacility(id) {
      this.$store.dispatch('setIsChangingFacilityOnCurrentBrowser', true);
      await this.$store.dispatch('changeCurrentUserFacility', { newFacilityId: id, redirectEnabled: false })
    },
    routeToReports() {
      this.$router.push("/reports");
    },
    routeToLifestyleResidentsReport() {
      this.$router.push("/reports/residentsLifestyleEventsReport")
    },
    getEventsByDates() {
      this.loading = true
      this.$store.dispatch("getLifestyleEventsReportData", {
        startDate: moment(this.startDate).startOf('day').toDate(),
        endDate: moment(this.endDate).endOf('day').toDate()
      });
    },
    getDailyCount(events) {
      const types = events.reduce(function (totals, event) {
        const date = moment(event.start)
          .startOf("day")
          .format("MMM  D");
        !totals[date] ? (totals[date] = 1) : (totals[date] = totals[date] + 1);
        return totals;
      }, {});
      return types;
    },
    groupByDay(events) {
      const weekDays = getWeekDaysFromDateRange(moment(this.startDate), moment(this.endDate))
      const week = weekDays.reduce((o, key) => ({ ...o, [key]: undefined }), {})
      const types = events.reduce(function (totals, event) {
        const dayOfWeek = moment(event.start).format("dddd");
        !week[dayOfWeek] ? (week[dayOfWeek] = 1) : (week[dayOfWeek] = totals[dayOfWeek] + 1);
        return week;
      }, {});
      return types;
    },
    groupByHour(events) {
      const timeFormat = this.timeFormat
      const types = events.reduce(function (totals, event) {
        const dayOfWeek = moment(event.start).format(timeFormat);
        !totals[dayOfWeek]
          ? (totals[dayOfWeek] = 1)
          : (totals[dayOfWeek] = totals[dayOfWeek] + 1);
        return totals;
      }, {});
      return types;
    },
    handleChangePeriod(period) {
      this.startDate = moment()
        .subtract(1, period)
        .toISOString()
        .substring(0, 10);

      this.endDate = moment()
        .toISOString()
        .substring(0, 10);

      //reload report
      this.getEventsByDates()
    }
  }
}
